export const API_URL = "https://api.oratoriofmabari.it/api/";
export const API_KEY = "your-api-key";
export const MAX_RESULTS = 10;
export const DEFAULT_TITLE_SUFIX = " - Oratorio FMA San Girolamo Bari";
